import * as React from "react";
import Lightbox from "react-images";
import Attachment from "../../model/attachment/Attachment";
import {api} from "../../api/api";
import ImageUtils from "../../utils/ImageUtils";
import {AttachmentImageRotateButton, RotateType} from "./AttachmentImageRotateButton";

interface IComponentProps {
	/**
	 * Attachments
	 */
	attachments: Attachment[];
	/**
	 * On close lightbox callback
	 */
	onClose: () => void,
	/**
	 * Is lightbox open
	 */
	isOpen?: boolean
	/**
	 * Ignore checking the file extension
	 */
	ignoreExtension?: boolean
}

interface IState {
	/**
	 * Current image index
	 */
	currentImage: number;
	/**
	 * Images
	 */
	images: any[]

	isLoading: boolean
}

type Props = IComponentProps


export default class AttachmentImagesPreview extends React.Component<Props, IState> {

	public static defaultProps: Partial<Props> = {
		isOpen: true
	};

	constructor(props: Props) {
		super(props);
		this.state = ({currentImage: 0, images: [], isLoading: false});
		this.rotate = this.rotate.bind(this);
	}

	componentDidMount() {
		if (this.props.isOpen) {
			this.loadImages()
		}
	}

	componentWillReceiveProps(nextProps: Props) {
		if (!this.props.isOpen && nextProps.isOpen && !this.state.isLoading) {
			this.loadImages()
		}
	}

	loadImages() {
		this.setState({isLoading: true});
		let jpegFiles: Attachment[], otherFormatFiles: Attachment[];
		if (this.props.ignoreExtension) {
			jpegFiles = [];
			otherFormatFiles = this.props.attachments
		}
		else {
			let jpegFormats = [".jpg", ".jpeg", ".jpe"];
			let otherAllowedFormats = [".png", ".gif"];
			jpegFiles = this.props.attachments.filter(a => jpegFormats.some(f => a.name.toLowerCase().indexOf(f) > -1));
			otherFormatFiles = this.props.attachments.filter(
				a => otherAllowedFormats.some(f => a.name.toLowerCase().indexOf(f) > -1));
		}

		let images: any[] = [].concat(jpegFiles).concat(otherFormatFiles).map(att => {
			return {
				src: "/assets/img/rolling.svg",
				caption: att.description.getOrElse("")
			}
		});

		let fetched = 0;
		const isLoading = jpegFiles.length + otherFormatFiles.length !== ++fetched;
		this.setState({images, isLoading});

		jpegFiles.map((attachment, index) => {
			api.instance.attachmentApi.downloadFile(attachment.id).then((buffer) => {
				ImageUtils.resetOrientation(buffer, resetImage => {
					images[index] = {...images[index], src: resetImage};
					const isLoading = images.length !== ++fetched;
					this.setState({images, isLoading});
				})
			})
		});
		otherFormatFiles.map((attachment, index) => {
			api.instance.attachmentApi.downloadFile(attachment.id).then((buffer) => {
				ImageUtils.getImageAsSrcString(buffer, src => {
					const currentIndex = jpegFiles.length + index;
					images[currentIndex] = {...images[currentIndex], src};
					const isLoading = images.length !== ++fetched;
					this.setState({images, isLoading});
				})
			})
		});
	}


	render() {
		return (
			!!this.state.images.length
			&& <Lightbox images={this.state.images}
						 onClose={() => {this.setState({currentImage: 0}, this.props.onClose)}}
						 currentImage={this.state.currentImage}
						 isOpen={this.props.isOpen}
						 showThumbnails
						 backdropClosesModal
						 onClickNext={() => { this.setState({currentImage: this.state.currentImage + 1}) }}
						 onClickPrev={() => { this.setState({currentImage: this.state.currentImage - 1}) }}
						 onClickThumbnail={(index) => {this.setState({currentImage: index})}}
						 customControls={this.getRotateButtons()}/>
		)
	}

	private getRotateButtons(): any[] {
		return [
			<div key={'rotate-wrapper'} style={{display: 'flex', alignItems: 'center'}}>
				<AttachmentImageRotateButton direction={RotateType.CounterClockWise} onClick={this.rotate}/>
				<AttachmentImageRotateButton direction={RotateType.ClockWise} onClick={this.rotate}/>
			</div>
		]
	}

	private rotate(direction: RotateType) {
		let degrees: number = 90;
		if (direction === RotateType.CounterClockWise) {
			degrees = -90;
		}
		ImageUtils.rotate(degrees, this.state.images[this.state.currentImage].src, src => {
			this.setRotatedImage(src);
		});
	}

	private setRotatedImage(srcBase64: string) {
		let images = [...this.state.images];
		images[this.state.currentImage] = {...images[this.state.currentImage], src: srcBase64};
		this.setState({images});
	}
}
